module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Navigation/Down-left-44a972a4982082b08a653e564a5548d5.svg";